/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const LockKeyholeOpenSolidV6 = (props) => (
  <Icon {...props} name="Lock Keyhole Open Solid V6">
    <path d="M12 2.667a2.222 2.222 0 0 0-2.222 2.222v1.333h.889A1.78 1.78 0 0 1 12.445 8v5.333a1.78 1.78 0 0 1-1.778 1.778H1.778A1.779 1.779 0 0 1 0 13.333V8c0-.981.796-1.778 1.778-1.778H8V4.889a4 4 0 0 1 8 0v1.333c0 .492-.397.889-.889.889s-.889-.397-.889-.889V4.889A2.222 2.222 0 0 0 12 2.667zm-4.889 8.889c.492 0 .889-.397.889-.889s-.397-.889-.889-.889H5.333c-.492 0-.889.397-.889.889s.397.889.889.889h1.778z" />
  </Icon>
);

export default LockKeyholeOpenSolidV6;
